export enum ApprovalState {
	/**
	 * 대기
	 */
   WAIT,
	
   /**
    * 승인
    */
   APPROVED,
   
   /**
    * 반려
    */
   REJECT,
   
   /**
    * 취소
    */
   CANCEL
}

export const ApprovalStates = [
  {
    value: ApprovalState[ApprovalState.WAIT],
    label: '대기중',
    status: 'basic'
  },
  {
    value: ApprovalState[ApprovalState.APPROVED],
    label: '승인',
    status: 'success'
  },
  {
    value: ApprovalState[ApprovalState.REJECT],
    label: '반려',
    status: 'danger'
  },
  {
    value: ApprovalState[ApprovalState.CANCEL],
    label: '취소',
    status: 'warning'
  },
];
